import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import * as modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: modules,
  getters,
  actions,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js